import type { NavbarItemProps } from '@vlabs/uikit';
import { NavbarItem as UIKitNavbarItem } from '@vlabs/uikit';
import { NavLink } from 'react-router-dom';

import { useNavbarContext } from '../useNavbarContext';

function NavbarItem({
  as = NavLink,
  format = undefined,
  ...props
}: NavbarItemProps<typeof NavLink>): React.JSX.Element {
  const ctx = useNavbarContext();

  return (
    <UIKitNavbarItem
      {...props}
      as={as}
      format={format ?? ctx.type}
    />
  );
}

export { NavbarItem };
